import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// Router
import VueRouter from 'vue-router'
import routes from './routes.js'

Vue.use(VueRouter)

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (localStorage.getItem('token') == null && to.path != '/') next('/')
  else next()
})


// Axios

var endpoint = process.env.VUE_APP_API_URL || (process.env.NODE_ENV === 'production'
  ? 'https://roadme-api.campaniasistemi.it/'
  : 'http://localhost:9000/');



import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

axios.defaults.baseURL = endpoint;
axios.defaults.withCredentials = false; // for sessions (not valid for ANCSERVIZI)

axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    if (localStorage.getItem("token")) {
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    } else {
      config.headers["Authorization"] = "";
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Response interceptor to rewrite production and relative/incomplete photo URLs for the demo
function processUrl(val) {
  if (typeof val !== 'string' || !val) return val;

  const base = axios.defaults.baseURL.endsWith('/') ? axios.defaults.baseURL : axios.defaults.baseURL + '/';

  // Case 1: starts with https://roadme.campaniasistemi.it/ (with single or double slash before foto)
  if (val.startsWith('https://roadme.campaniasistemi.it/')) {
    const match = val.match(/https:\/\/roadme\.campaniasistemi\.it\/\/?foto\/(.+)$/);
    if (match) {
      return base + 'foto/' + match[1];
    }
  }

  // Case 2: starts with '//foto/' or '/foto/' or 'foto/'
  // e.g. //foto/14-05-2026/1f62596d-7203-43d5-a3db-3b9b5b4377de.jpg
  if (val.includes('foto/')) {
    const match = val.match(/(?:\/)?\/foto\/(.+)$/);
    if (match) {
      return base + 'foto/' + match[1];
    }
    const matchRelative = val.match(/^foto\/(.+)$/);
    if (matchRelative) {
      return base + 'foto/' + matchRelative[1];
    }
  }

  // Case 3: just a filename ending with .jpg, .jpeg, .png (e.g. 1b856636-5e7e-4ce0-a62f-a36c5148c300.jpg)
  // but it doesn't contain slashes (i.e. it's just the file name)
  if (val.endsWith('.jpg') || val.endsWith('.jpeg') || val.endsWith('.png')) {
    if (!val.includes('/')) {
      return base + 'foto/' + val;
    }
  }

  return val;
}

function rewriteProductionUrls(data) {
  if (!data) return;
  if (Array.isArray(data)) {
    for (let i = 0; i < data.length; i++) {
      if (typeof data[i] === 'object') {
        rewriteProductionUrls(data[i]);
      } else if (typeof data[i] === 'string') {
        data[i] = processUrl(data[i]);
      }
    }
  } else if (typeof data === 'object') {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        if (typeof data[key] === 'object') {
          rewriteProductionUrls(data[key]);
        } else if (typeof data[key] === 'string') {
          data[key] = processUrl(data[key]);
        }
      }
    }
  }
}

axios.interceptors.response.use(
  function (response) {
    if (response && response.data) {
      rewriteProductionUrls(response.data);
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Tooltip
import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

// Modals
import VModal from 'vue-js-modal'
Vue.use(VModal)

// SweetAlert
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Swal from 'sweetalert2';
// RoadME theme overrides for SweetAlert2 popups (brand tokens: orange #F7931E, navy #1A2238)
import './assets/swal-roadme.css';
// Register with RoadME theme defaults so every $swal call inherits the brand look.
// confirmButtonColor #F7931E (arancione RoadME), cancelButtonColor #1A2238 (navy),
// plus customClass hooks for radius/typography. Semantic success/error/warning/info
// icons stay unchanged; only the appearance is themed, not the logic.
Vue.use(VueSweetalert2, {
  confirmButtonColor: '#F7931E',
  cancelButtonColor: '#1A2238',
  buttonsStyling: true,
  customClass: {
    popup: 'roadme-popup',
    title: 'roadme-title',
    confirmButton: 'roadme-confirm',
    cancelButton: 'roadme-cancel'
  }
});

// Instance Toast per notifiche veloci non bloccanti
const ToastMixin = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  customClass: {
    popup: 'roadme-toast-popup',
    title: 'roadme-toast-title',
    htmlContainer: 'roadme-toast-html'
  },
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  }
});

const toastHelper = (titleOrOptions, text, icon) => {
  if (typeof titleOrOptions === 'object') {
    return ToastMixin.fire(titleOrOptions);
  }
  return ToastMixin.fire({
    title: titleOrOptions,
    text: text || '',
    icon: icon || 'success'
  });
};
toastHelper.fire = toastHelper;
toastHelper.success = (title, text) => ToastMixin.fire({ icon: 'success', title: title || 'Salvato!', text: text || '' });
toastHelper.error = (title, text) => ToastMixin.fire({ icon: 'error', title: title || 'Errore', text: text || '' });
toastHelper.warning = (title, text) => ToastMixin.fire({ icon: 'warning', title: title || 'Attenzione', text: text || '' });
toastHelper.info = (title, text) => ToastMixin.fire({ icon: 'info', title: title || 'Info', text: text || '' });

Vue.prototype.$toast = toastHelper;

if (Vue.prototype.$swal) {
  Vue.prototype.$swal.fire = Vue.prototype.$swal;
  Vue.prototype.$swal.toast = toastHelper;
  Object.getOwnPropertyNames(Swal).forEach((method) => {
    if (typeof Swal[method] === 'function' && !Vue.prototype.$swal[method]) {
      Vue.prototype.$swal[method] = Swal[method].bind(Swal);
    }
  });
}

// Tag Input
import VoerroTagsInput from '@voerro/vue-tagsinput';
Vue.component('tags-input', VoerroTagsInput);

// Global image fallback directive: use v-img-fallback on any <img>
// to automatically show a placeholder when the image is missing or broken.
Vue.directive('img-fallback', {
  bind(el) {
    el.addEventListener('error', () => {
      el.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect width='400' height='300' fill='%23f0f2f5'/%3E%3Cg fill='%23b0b7c3'%3E%3Crect x='150' y='90' width='100' height='80' rx='8'/%3E%3Ccircle cx='200' cy='75' r='20'/%3E%3Crect x='120' y='175' width='160' height='12' rx='6'/%3E%3Crect x='145' y='195' width='110' height='10' rx='5'/%3E%3C/g%3E%3Ctext x='200' y='240' text-anchor='middle' font-family='Arial,sans-serif' font-size='13' fill='%23b0b7c3'%3ENessuna foto disponibile%3C/text%3E%3C/svg%3E";
      el.style.objectFit = 'contain';
      el.style.background = '#f0f2f5';
      el.style.padding = '0';
    });
  }
});

// Global uppercase filter
Vue.filter('uppercase', val => val ? val.toUpperCase() : '');

// VueLayers
import VueLayers from 'vuelayers'
import 'vuelayers/lib/style.css' // needs css-loader

Vue.use(VueLayers)

// VueLeaflet
import { LMap, LTileLayer, LMarker, LIcon, LGeoJson, LPopup, LPolyline, LTooltip } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-icon', LIcon);
Vue.component('l-geo-json', LGeoJson);
Vue.component('l-popup', LPopup);
Vue.component('l-polyline', LPolyline);
Vue.component('l-tooltip', LTooltip);

import { Icon } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

import * as firebase from "firebase/app";
import "firebase/messaging"

const firebaseConfig = {
  apiKey: "AIzaSyDAbNOqdDRdYfpnVnYJyEsv94TxAQn0GdQ",
  authDomain: "roadme-e5909.firebaseapp.com",
  projectId: "roadme-e5909",
  storageBucket: "roadme-e5909.firebasestorage.app",
  messagingSenderId: "186073488848",
  appId: "1:186073488848:web:331b7bfef6135085212dd5"
};

firebase.initializeApp(firebaseConfig)

Vue.prototype.$messaging = firebase.messaging()
Vue.prototype.$messaging.usePublicVapidKey('BA0OBjGR33htfdr1BVCzjrTo4ppHdVaaEDS5UaweUOa1jrq2dQeQBj_9fEvgCQuqKQpjNGwO0Bz9zCsFqnMWa3I')

navigator.serviceWorker.register('/firebase-messaging-sw.js')
  .then((registration) => {
    Vue.prototype.$messaging.useServiceWorker(registration)
  }).catch(err => {
    console.log(err)
  })

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
